import React from 'react'
import { Link } from 'react-router-dom'

import ViewIcon from 'Assets/Images/icons/view'
import EditIcon from 'Assets/Images/icons/edit'

export const ClientCardUnstyled = props => {
  return (
    <div
      className={props.className + ' card-wrapper'}
      onClick={() => {
        props.onClickHandler(props.viewPath || '')
      }}
    >
      <div className="card">
        <div className="client-name">
          <img src={props.client.logo} alt="logo" />
          {props.client.name}
        </div>
        <Link
          className="view"
          to={props.viewPath || ''}
          onClick={event => {
            event.stopPropagation()
          }}
        >
          <ViewIcon />
          View
        </Link>
        <Link
          className="edit"
          to={props.editPath || ''}
          onClick={event => {
            event.stopPropagation()
          }}
        >
          <EditIcon />
          Edit
        </Link>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/Components/Clients/ClientCard/unstyled.js